// src/pages/Services.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import Card3D from "../components/Card3D";
import Carousel from "../components/Carousel";
import AccordionFAQ from "../components/AccordionFAQ";

const Services = () => {
  const navigate = useNavigate();

  const Hero = ({ title, subtitle, images, backgroundImage, showButtons = true }) => (
  <div className="relative h-screen z-10 overflow-hidden">
    {/* Background Image */}
    <div 
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: `url(${backgroundImage || images[0]})` }}
    >
      <div className="absolute inset-0 bg-black/40"></div>
    </div>

    

    {/* Content Overlay */}
        <div className="relative z-10 h-full flex items-center text-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
            <div className="mx-auto max-w-2xl">
              <h1 className="font-libre text-4xl md:text-5xl lg:text-6xl font-medium text-white mb-6">
                {title}
              </h1>
              <p className="font-inter text-lg text-gray-200">
                {subtitle}
              </p>
            </div>
          </div>
        </div>
  </div>
)


  const services = [
    {
      title: 'Deals & Transactions Advisory',
      description: 'Support for acquisitions, disposals, and capital transactions',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      )
    },
    {
      title: 'Property Marketing',
      description: 'Go-to-market and leasing campaigns that maximize uptake',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
        </svg>
      )
    },
    {
      title: 'Green Building Solutions',
      description: 'ESG-aligned advisory and sustainability integration',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      )
    },
    {
      title: 'Design & Build',
      description: 'Integrated planning, design and delivery',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
        </svg>
      )
    },
    {
      title: 'Experience Management',
      description: 'Tenant/Customer experience programs that retain value',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      )
    },
    {
      title: 'Data Management Solutions',
      description: 'Data pipelines, dashboards, and analytics for decisions',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
        </svg>
      )
    },
    {
      title: 'Letting',
      description: 'Market strategies, tenant mix, and vacancy reduction',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
        </svg>
      )
    },
    {
      title: 'ValuAnalytics',
      description: 'Advanced valuations modeling and market intelligence',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      )
    }
  ]

  const caseStudies = [
    {
      title: "Commercial Portfolio Optimization",
      client: "Prime Properties Ltd",
      service: "Portfolio Management",
      challenge: "Underperforming commercial portfolio in Accra CBD with high vacancy rates.",
      solution: "Strategic repositioning, tenant mix optimization, and operational efficiency improvements.",
      results: [
        "25% increase in rental income within 6 months",
        "Vacancy rate reduced from 35% to 8%",
        "Portfolio value increased by 18%",
      ],
    },
    {
      title: "Market Entry Strategy",
      client: "International Developer",
      service: "Market Research & Advisory",
      challenge: "Entering the Nigerian residential market with limited local knowledge.",
      solution: "Comprehensive market analysis, competitive benchmarking, and phased entry strategy.",
      results: [
        "Successful launch of 200-unit development",
        "85% pre-sales achieved before construction",
        "Market share captured within first year",
      ],
    },
    {
      title: "Sustainable Development Advisory",
      client: "GreenBuild Africa",
      service: "Sustainability Consulting",
      challenge: "Achieving green building certification for mixed-use development.",
      solution: "Sustainability integration, certification guidance, and environmental impact assessment.",
      results: [
        "LEED Gold certification achieved",
        "30% reduction in energy consumption",
        "Enhanced market positioning and premium pricing",
      ],
    },
  ];

  const faqs = [
    {
      question: "What standards do you follow for property valuation?",
      answer:
        "We adhere to RICS Valuation - Global Standards (Red Book) and International Valuation Standards. All our valuations comply with local regulations while maintaining international best practices.",
    },
    {
      question: "How long does a typical valuation take?",
      answer:
        "Most residential valuations are completed within 3-5 business days. Commercial and industrial properties may take 1-2 weeks depending on complexity and site access.",
    },
    {
      question: "Do you provide services across Africa?",
      answer:
        "Yes, we operate across multiple African markets including Ghana, Nigeria, Kenya, Tanzania, South Africa, and others with local expertise in each region.",
    },
    {
      question: "Can you help with international investment in African real estate?",
      answer:
        "Absolutely. We specialize in assisting international investors with market entry strategies, due diligence, and portfolio management.",
    },
  ];

  return (
    
    <div className="relative min-h-screen overflow-hidden">
      <Hero 
        title="Our Services"
        subtitle="We provide integrated lifecycle solutions across the property consultancy value chain."
        backgroundImage="/high-angle-view-city-sunset.jpg"
        showButtons={false}
      />


      {/* Page Content */}
      <div className="relative z-10">
        {/* Expertise */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="mb-12">
          <p className="text-sm text-gray-600 uppercase tracking-wider mb-4">OUR EXPERTISE</p>
          <h2 className="font-inter text-3xl md:text-4xl font-bold text-gray-900 max-w-3xl">
            We provide integrated, lifecycle solutions across the property consultancy value chain
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow duration-300 font-inter"
            >
              {/* Icon */}
              <div className="w-12 h-12 bg-blue-900 rounded-lg flex items-center justify-center text-white mb-4">
                {service.icon}
              </div>
              
              {/* Title */}
              <h3 className="font-inter text-lg font-semibold text-gray-900 mb-3">
                {service.title}
              </h3>
              
              {/* Description */}
              <p className="text-sm text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>




      {/* CTA Section */}
      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className=" rounded-2xl p-12 text-center relative overflow-hidden" style={{ backgroundColor: '#0A1F5C' }}>
          {/* Bottom Left Circle */}
          <div className="absolute bottom-0 left-0 w-40 h-40 border-4 border-white rounded-full -translate-x-28 translate-y-10 opacity-30"></div>

          {/* Top Right Circle */}
          <div className="absolute top-0 right-0 w-40 h-40 border-4 border-white rounded-full translate-x-28 -translate-y-10 opacity-30"></div>

          <div className="relative z-10">
            <h2 className="font-inter font-medium text-3xl md:text-4xl font-bold text-white mb-8">
              Let's Build The Future Together
            </h2>
            <div className="flex flex-col sm:flex-row justify-center gap-4 font-inter">
              <a href="/services">
                <button className="px-8 py-3 bg-black text-white font-medium rounded-lg hover:bg-gray-800 transition-colors duration-300">
                  Learn More
                </button>
              </a>
              <a href="/contact">
                <button className="px-8 py-3 bg-yellow-400 text-gray-900 font-medium rounded-lg hover:bg-yellow-500 transition-colors duration-300">
                  Start a Project
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
      </div>

      {/* Animations */}
      <style>{`
        @keyframes doodleMove {
          0% { transform: translate(0,0); }
          50% { transform: translate(-20px,-40px); }
          100% { transform: translate(0,0); }
        }

        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }

        .animate-doodleMove {
          animation: doodleMove 90s linear infinite;
        }

        .animate-shimmer {
          animation: shimmer 8s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default Services;
